import {Cureus} from '../Cureus';

Cureus.PersonIndex= {}
//= require_tree ./PersonIndex